@if (print && filter) {
<app-print-filter-data [filter]="filter" />
} @for (dataset of data; track $index) {
<app-line-chart [labels]="dataset.labels" [datasets]="dataset" />
}@empty {
<div class="empty">
  <p>Não há dados para exibir</p>
</div>
}
